<template>
	<app-modal title="⚠️ Notifications Warning">
		<div class="flex flex-col place-items-center px-2">
			<span>Notifications are blocked in your browser settings.</span>
			<span>Please enable them manually then reload the page.</span>
			<span>{{ $t('do_you_need_support') }} {{ $t('contact_us') }}</span>
			<img src="@/assets/images/notifications.png" class="mt-2 shadow-lg" alt="Notifications" />
		</div>
	</app-modal>
</template>

<script>
	import AppModal from '@/components/app/AppModal.vue';

	export default {
		name: 'AppNotificationWarningModal',
		components: { AppModal },
	};
</script>

<style scoped></style>
